"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Login["default"];
  }
});
var _Login = _interopRequireDefault(require("./Login"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }